
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(13[23]|539|979)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
